import React, { FC } from 'react'
import SkeletonText from '../SkeletonText'
import ThumbnailSkeleton from '../ThumbnailSkeleton'
import './index.scss'

/** 列表模式的skeleton */
const ListSkeleton: FC = () => {
  return (
    <div className='list-skeleton'>
      {
        new Array(4).fill(1).map((item, index) => {
          return (
            <div key={index}>
              {
                index % 3 === 0 && (
                  <div className='title'>
                    <SkeletonText animated style={{ width: '15%', height: '18px' }} />
                  </div>
                )
              }
              <ThumbnailSkeleton key={index} className='list-skeleton-item' />
            </div>
          )
        })
      }
    </div>
  )
}

export default ListSkeleton
